export const ICON_PLACEMENTS = {
  left: 'left',
  right: 'right',
};

export const DESCRIPTION_PLACEMENTS = {
  right: 'right',
  bottom: 'bottom',
};

export const SIZES = {
  small: 'small',
  medium: 'medium',
};
